import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Crown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import { CpmClipperLeaderboard } from '@/components/cpm/CpmClipperLeaderboard';
import { cn } from '@/lib/utils';

/**
 * The /earn clipper leaderboard, closed by default so the season hall of fame
 * leads the page. Radix unmounts closed content, so the leaderboard's queries
 * only run once the viewer opens it.
 */
export function CollapsibleCpmLeaderboard() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="space-y-3">
      <div className="flex justify-center">
        <CollapsibleTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-2 text-muted-foreground">
            <Crown className="w-4 h-4" aria-hidden="true" />
            {open ? t('earnPage.hideLeaderboard') : t('earnPage.showLeaderboard')}
            <ChevronDown
              className={cn('w-4 h-4 transition-transform', open && 'rotate-180')}
              aria-hidden="true"
            />
          </Button>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent>
        <CpmClipperLeaderboard variant="standing" />
      </CollapsibleContent>
    </Collapsible>
  );
}
